export const types = [{
    text: 'Машиноместо',
    value: 'parkingPlace'
}, {
    text: 'Гараж',
    value: 'garage'
}, {
    text: 'Бокс',
    value: 'box'
}];

export const garageTypes = [{
    text: 'Встроенный',
    value: 'builtIn'
}, {
    text: 'Капитальный',
    value: 'capital'
}, {
    text: 'Ракушка',
    value: 'shell'
}, {
    text: 'Самострой',
    value: 'samostroy'
}];

export const boxTypes = [{
    text: 'Кирпичный',
    value: 'brick'
},{
    text: 'Металлический',
    value: 'metal'
}];
